module.exports = __webpack_public_path__ + "static/media/1023544.77bedf03.png";